import api from '@/api/index.js'

const emv_taps_summary_report = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_EMV_TOTAL_SUMMARY_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_EMV_TAPS_SUMMARY_REPORT: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_EMV_TAPS_SUMMARY_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    GetEmvTapsSummaryReport({commit}, query) {
      let reqQueryStr = '';
      if (query.ignoreCache === true) {
        reqQueryStr += 'ignore-cache=t&'
      }

      reqQueryStr = `to=${query.toDate.to}`

      commit('SET_EMV_TAPS_SUMMARY_REPORT_ERROR', null)
      commit('SET_EMV_TAPS_SUMMARY_REPORT', null)
      commit('SET_EMV_TOTAL_SUMMARY_REPORT_LOADING', true)
      return api.get('reports/emv-taps-summary?' + reqQueryStr)
        .then((response) => {
          commit('SET_EMV_TAPS_SUMMARY_REPORT', response)
        })
        .catch((error) => {
          commit('SET_EMV_TAPS_SUMMARY_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_TOTAL_SUMMARY_REPORT_LOADING', false)
        })
    }
  },
}

export default emv_taps_summary_report
